import { useEffect } from 'react';
import { UseLazyQuery } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { QueryDefinition } from '@reduxjs/toolkit/query';

/**
 * Wraps an RTK Query lazy-query hook so it automatically triggers whenever `condition` becomes truthy, returning the query state as a positional tuple for convenient destructuring.
 *
 * @param condition - Truthy value that triggers the lazy query when it changes; the query fires whenever this is truthy.
 * @param queryHook - An RTK Query lazy-query hook (as returned by `endpoint.useLazy<X>Query`).
 * @returns A tuple of `[result, isLoading, isSuccess, isFetching, isError, error, trigger]`.
 */
export default function useAgLazyQuery<T>(
  condition: any,
  queryHook: UseLazyQuery<QueryDefinition<any, any, any, T, any>>
): [T, boolean, boolean, boolean, boolean, any, any] {
  //TODO: Figure out how to correctly cast result to interface represented by T, and remove all the casting like "opportunityToDisplay as Opportunity"
  const [trigger, { data: result, isFetching, isLoading, isSuccess, isError, error }] = queryHook();

  useEffect(() => {
    if (condition) trigger(condition);
  }, [condition]);
  return [result as T, isLoading, isSuccess, isFetching, isError, error, trigger];
}
